import {Component, OnInit} from '@angular/core';
import {MenuController, Platform, PopoverController} from '@ionic/angular/standalone';
import {IonApp, IonRouterOutlet, IonSplitPane, IonMenuToggle, IonContent, IonList, IonLabel, IonMenu, IonListHeader} from '@ionic/angular/standalone';
import {Events} from './services/events.service';
import {User, UserService} from './services/user.service';
import {ConnectionService} from './services/connection.service';
import {ListPopoverComponent} from './components/list-popover/list-popover.component';
import {Router, RouterLink} from '@angular/router';
import {Subscription} from 'rxjs';
import {registerLocaleData} from '@angular/common';
import localeDe from '@angular/common/locales/de';

import { TranslateService, TranslateModule } from '@ngx-translate/core';
import {StorageService} from './services/storage.service';
import {SettingsService} from './services/settings.service';

import {Capacitor} from '@capacitor/core';
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support';
import { StatusBar } from '@capacitor/status-bar';

import {TrackingService} from './services/tracking.service';

import { VERSION } from './constants';

import { UtilService } from './services/util.service';

import { IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { settingsSharp, settingsOutline, cloudUploadSharp, cloudUploadOutline, cogOutline, cogSharp } from 'ionicons/icons';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: true,
    imports: [IonApp, IonRouterOutlet, TranslateModule, RouterLink, IonIcon, IonSplitPane, 
        IonMenuToggle, IonContent, IonList, IonLabel, IonMenu, IonListHeader]
})
export class AppComponent implements OnInit {

    user: User;
    loginChangeSub: Subscription;
    connectionChangeSub: Subscription;

    constructor(
        private connectionService: ConnectionService,
        private events: Events,
        private menuCtrl: MenuController,
        private platform: Platform,
        private popoverCtrl: PopoverController,
        private router: Router,
        private settingsService: SettingsService,
        private storage: StorageService,
        private translate: TranslateService,
        private userService: UserService,
        private util: UtilService,
        private trackingService: TrackingService,
    ) {
        addIcons({ settingsSharp, settingsOutline, cloudUploadSharp, cloudUploadOutline, cogOutline, cogSharp });
    }

    async ngOnInit() {
        await this.platform.ready();
        if ((this.platform.is('android') || this.platform.is('ios')) && Capacitor.getPlatform() !== 'web') {
            await EdgeToEdge.enable();
            const insets = await EdgeToEdge.getInsets();
            console.log('Insets:', insets);
            // color has to be a hex string
            await StatusBar.setBackgroundColor({color: '#546e7a'});
        }
        console.log('App init. Version: ', VERSION);

        registerLocaleData(localeDe, 'de');
        let selectedLanguage = await this.storage.get('set-language') || this.translate.getCurrentLang() || 'auto';
        console.log('selectedLanguage on app start', selectedLanguage, this.translate.getCurrentLang());
        await this.settingsService.setLanguage(selectedLanguage, true, false);

        await this.connectionService.setupSubscriptions();

        const connected = await this.connectionService.getConnectionStatus();
        if (!connected) {
            this.util.showNoConnectionAlert();
        } else {
            await this.userService.restore();
        }

        this.loginChangeSub = this.events.subscribe('user:login-change', (user) => {
            this.user = user;
            console.log(this.user);
        });

        this.connectionChangeSub = this.events.subscribe('connection:change', (connected) => {
            console.log('connection change subscription in app component', connected);
            if (!connected) {
                this.util.showNoConnectionAlert();
            } else {
                this.userService.restore();
            }
        });
        
        let consent = await this.settingsService.get('tracking-consent');
        if (consent === undefined) {
            consent = await this.trackingService.askForTrackingConsent();
            await this.settingsService.set('tracking-consent', consent);
        }
        await this.trackingService.toggleTracking(consent);
    }

    async showUserPopover(event: MouseEvent) {
        const popover = await this.popoverCtrl.create({
            component: ListPopoverComponent,
            componentProps: {
                items: [{
                    id: 'settings',
                    title: 'Benutzerprofil'
                }, {
                    id: 'logout',
                    title: 'Abmelden'
                }],
                popoverCtrl: this.popoverCtrl
            },
            event
        });
        popover.onDidDismiss().then(detail => this.onUserPopoverDismiss(detail.data.selected));
        await popover.present();
    }

    async onUserPopoverDismiss(selectedItem) {
        switch (selectedItem.id) {
            case 'settings':
                await this.router.navigate(['/settings']);
                break;
        }
        await this.menuCtrl.close();
    }
}
